import { render, staticRenderFns } from "./CandidateCursor.vue?vue&type=template&id=e5d156e4&scoped=true&"
import script from "./CandidateCursor.vue?vue&type=script&lang=js&"
export * from "./CandidateCursor.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCursor.vue?vue&type=style&index=0&id=e5d156e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d156e4",
  null
  
)

export default component.exports